/**
 * Merges two arrays, one of `ColDef` and one of `ColumnState`, and deduplicates them.
 * @remarks ColDef uses `field` and ColumnState uses `colId` to identify columns.
 * @privateRemarks For restoring saved `ColumnState` but also keep custom renderers and other `ColDef` properties.
 * @public
 */
export function mergeAndDedupColDefWithColumnState(colDefs, columnStates) {
    const merged = {};
    const deduplicated = [];
    const fieldProp = 'field';
    const colIdProp = 'colId';
    columnStates.forEach((state) => {
        const matchingColDef = colDefs.find((item) => item[fieldProp] === state[colIdProp] ||
            (item[colIdProp] && item[colIdProp] === state[colIdProp]));
        if (matchingColDef) {
            const colDefStateMerge = Object.assign(Object.assign({}, matchingColDef), state);
            merged[matchingColDef[fieldProp]] = colDefStateMerge;
            deduplicated.push(colDefStateMerge);
        }
    });
    colDefs.forEach((def) => {
        if (!merged.hasOwnProperty(def[fieldProp])) {
            const newObj = Object.assign({}, def);
            merged[def[fieldProp]] = newObj;
            deduplicated.push(newObj);
        }
    });
    return deduplicated;
}
